import { render, staticRenderFns } from "./testOrderDetail.vue?vue&type=template&id=c8f8e1bc&scoped=true&"
import script from "./testOrderDetail.vue?vue&type=script&lang=js&"
export * from "./testOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./testOrderDetail.vue?vue&type=style&index=0&id=c8f8e1bc&prod&lang=scss&scoped=true&"
import style1 from "./testOrderDetail.vue?vue&type=style&index=1&id=c8f8e1bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f8e1bc",
  null
  
)

export default component.exports